import React, { useContext } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const partners = {
  rozetka:
    'https://rozetka.com.ua/ua/sigareti/c4638591/price=1700-1700;producer=parliament;tolshchina139079=tonkie/?utm_source=PMUsmsPrlm_Line',
  cig: 'https://cig-poshta.in.ua/product-tag/parliamentline-onepack/?utm_source=CDAsmsPrlm_Line'
};

const HomeScreen = () => {
  const { sendEvent } = useContext(DataLayerEventContext);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.headContainer}>
          <div className={styles.headShadow} />
          <div className={styles.bottomShadow} />
          <img
            className={styles.headBg}
            src={getImageFromS3('images/sms-prl-line/head-bg.gif')}
            alt="head-bg"
          />
        </div>
        <img
          className={styles.logo}
          src={getImageFromS3('images/sms-prl-line/logo.png')}
          alt="logo"
        />
        <img
          className={styles.packs}
          src={getImageFromS3('images/sms-prl-line/packs.png')}
          alt="packs"
        />
        <div className={styles.characteristicContainer}>
          <div className={styles.tobaccoContainer}>
            <img
              src={getImageFromS3('images/sms-prl-line/tobacco.png')}
              alt="tobacco"
            />
            <p><span>Абсолютно нова</span><br /> високоякісна тютюнова<br /> суміш від Parliament</p>
          </div>
          <div className={styles.filterContainer}>
            <div className={styles.filterText}>
              <p className={styles.filterTitle}><b>Оригінальний<br /> Recessed™</b> фільтр</p>
              <p className={styles.filterDescription}>з ущільненою<br />повітряною камерою<br />та вугільною<br />частиною</p>
            </div>
            <img
              src={getImageFromS3('images/sms-prl-line/filter.png')}
              alt="filter"
            />
          </div>
          <div className={styles.formatContainer}>
            <div className={styles.formatText}>
              <p className={styles.formatTitle}>Формат</p>
              <p className={styles.formatDescription}>King Size Super<br />Slim ("Кінг сайз<br />супер слім")</p>
            </div>
            <img
              src={getImageFromS3('images/sms-prl-line/format.png')}
              alt="format"
            />
          </div>
        </div>
        <div className={styles.buyContainer}>
          <p className={styles.buyTitle}>Де купити?</p>
          <p className={styles.buyDescription}><b>Parliament Line</b> можна знайти у роздрібних точках продажу в твоєму місті або на офіційних онлайн сервісах, зокрема:</p>
          <div className={styles.buttonContainer}>
            <div
              onClick={() => {
                sendEvent('rozetka');
                window.open(partners.rozetka, '_blank');
              }}
            >
              <div className={styles.buttonItem}>
                <img
                  src={getImageFromS3('images/sms-prl-line/glass.png')}
                  alt="glass"
                />
                <p>rozetka</p>
              </div>
              <p>Можна замовити від одного<br /> блоку (10 пачок)</p>
            </div>
            <div
              onClick={() => {
                sendEvent('cig-poshta');
                window.open(partners.cig, '_blank');
              }}
            >
              <div className={styles.buttonItem}>
                <img
                  src={getImageFromS3('images/sms-prl-line/glass.png')}
                  alt="glass"
                />
                <p>Cig-Poshta</p>
              </div>
              <p>Можна замовити<br /> від однієї пачки</p>
            </div>
          </div>
        </div>
      </div>
      <div className={styles.footer}>
        Куріння викликає<br />серйозні<br />захворювання та<br />залежність<br />Дана інформація про<br />
        продукт надається<br />відповідно<br />до статті 15 Закону<br />України «Про захист<br />
        прав споживачів»
      </div>
      <div className={styles.unsubscribe}>
        Ти отримав(-ла) повідомлення, оскільки залишав(-ла) запит на отримання
        інформації про продукцію компаній Philip Morris в Україні. <br />
        <a href="/unsubscribe?returnLink=25-sms-prl-line">
          Відписатися від SMS тут.
        </a>
      </div>
    </div>
  );
};

export default HomeScreen;
